const EDITABLE = [
  "descricao", "descricao_tecnica", "codigo_interno", "codigo_omie", "categoria_id",
  "fabricante", "fornecedor_id", "codigo_fornecedor", "unidade", "foto_principal",
  "fotos_adicionais", "estoque_minimo", "estoque_seguranca", "estoque_ideal", "custo_medio",
  "localizacao_id", "criticidade", "lead_time_dias", "origem", "pais_origem",
  "observacoes_tecnicas", "status", "aplicacoes",
];

export function partPayload(form, canFinance) {
  const payload = Object.fromEntries(EDITABLE
    .filter((key) => form[key] !== undefined && (canFinance || key !== "custo_medio"))
    .map((key) => [key, form[key]]));
  ["estoque_minimo", "estoque_seguranca", "estoque_ideal", "lead_time_dias", ...(canFinance ? ["custo_medio"] : [])]
    .forEach((key) => {
      if (!(key in payload)) return;
      const value = Number(payload[key]);
      if (!Number.isFinite(value) || value < 0 || value > Number.MAX_SAFE_INTEGER ||
          (key === "lead_time_dias" && !Number.isInteger(value))) {
        throw new Error("Informe valores numéricos válidos e não negativos; lead time deve ser inteiro.");
      }
      payload[key] = value;
    });
  return payload;
}
